import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import momentJalaali from 'moment-jalaali';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { FraudAnalysisStatus, FraudRequest } from '../../fraud-dashboard.models';
import { FraudSessionExpiredError, getAnalysisProgress, parseFraudRows } from '../../fraud-dashboard.utils';

@Component({
  selector: 'app-fraud-analysis',
  templateUrl: './fraud-analysis.component.html',
  styleUrls: ['./fraud-analysis.component.css']
})
export class FraudAnalysisComponent implements OnInit, OnDestroy {
  readonly dateForm = new FormGroup({
    date: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'))
  });
  analysis: FraudAnalysisStatus | null = null;
  loading = false;
  error = '';

  private controller?: AbortController;
  private requestId = 0;

  constructor(
    private gurdService: GurdServiceService,
    private other: OtherService,
    private notification: NotificationService,
    private router: Router
  ) {}

  get progress(): number {
    return getAnalysisProgress(this.analysis);
  }

  ngOnInit(): void {
    void this.loadAnalysis();
  }

  ngOnDestroy(): void {
    this.requestId++;
    this.controller?.abort();
  }

  async loadAnalysis(): Promise<void> {
    const requestId = ++this.requestId;
    this.controller?.abort();
    const controller = this.controller = new AbortController();
    this.analysis = null;
    this.error = '';
    this.loading = true;

    try {
      const user = Number(this.gurdService.decrypt(localStorage.getItem('ID')));
      const session = this.gurdService.decrypt(localStorage.getItem('Session'));
      if (!Number.isInteger(user) || user <= 0 || !session) throw new FraudSessionExpiredError();
      const payload: FraudRequest = {
        iSystemUSer: user,
        strSession: session,
        strDate: this.dateForm.value.date
      };
      const response = await axios.post('Fraud_Dashboard_GetAnalysisStatus', payload, {
        timeout: 30000,
        signal: controller.signal
      });
      if (requestId !== this.requestId) return;
      this.analysis = parseFraudRows<FraudAnalysisStatus>(response.data)[0] || null;
    } catch (error) {
      if (requestId !== this.requestId) return;
      if (error instanceof FraudSessionExpiredError) {
        this.notification.showError('لطفا وارد سیستم شوید');
        this.other.removeLocalStorage();
        void this.router.navigate(['login'], { queryParams: { error: 'لطفا وارد سیستم شوید' } });
        return;
      }
      this.error = 'دریافت وضعیت تحلیل با خطا مواجه شد. دوباره تلاش کنید.';
    } finally {
      if (requestId === this.requestId) this.loading = false;
    }
  }
}
